<template>
  <v-container fluid fill-height class="pa-0">
    <v-layout class="pa-0" row>
      <!-- BUBBLE NAME OFICIAL FENCES -->
      <div ref="infoBubbleOFRef">
        <info-bubble-polygon-name
          v-if="showOfficialFenceName"
          :info="infoOfficialFenceSelected"
          @closeBubble="showOfficialFenceName = false"
        />
      </div>
      <v-flex class="btn-absolute">
        <!-- OFFICIAL FENCES -->
        <official-zones />

        <!-- SHOW FILTERS BUTTON -->
        <v-flex d-inline-flex align-center>
          <v-flex class="show-filter-style">
            <v-btn
              v-if="!showFilterHome"
              @click="displayFiltersHome(true)">
              <v-icon left>filter_list</v-icon>
              Mostrar Filtros
            </v-btn>
          </v-flex>

          <!-- INFO ABOUT APLIED FILTER -->
          <v-flex
            d-inline-flex
            align-center
            v-if="!showFilterHome"
            elevation-1
            px-2
            class="info-filter-absolute"
          >
            <v-flex>
              <v-icon left>directions_car</v-icon>
            </v-flex>
            <v-flex d-inline-flex align-center>
              <v-flex>
                Vehículos Filtrados
              </v-flex>
              <v-flex v-if="showClearFilterBtn">
                <b class="pl-1 highlight-text">{{ filterType }}</b>
              </v-flex>
              <v-flex v-if="isFiltering" pl-2 pt-1>
                <v-progress-circular
                  :size="24"
                  :width="2"
                  color="primary"
                  indeterminate
                />
              </v-flex>
              <v-flex v-else>
                <b style="font-size: 24px;" class="pl-2 pt-1">
                  {{ currentMarkersLength }}
                </b>
              </v-flex>
            </v-flex>
            <!-- CLEAR FILTER BUTTON -->
            <v-flex 
              v-if="showClearFilterBtn"
              d-inline-flex
              align-baseline
              class="text-xs-center"
              pl-4
            >
              <v-flex class="caption font-weight-bold">
                Limpiar Filtro
              </v-flex>
              <v-flex>
                <v-btn
                  color="primary"
                  fab
                  small
                  depressed
                  @click="clearFilter"
                >
                  <v-icon>clear</v-icon>
                </v-btn>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-flex>

        <!-- SEARCH ARDDRESS -->
        <place-searcher
          parentComp="base-vehicles"
          :map="mapRef"
          @toMap="placeToMap"
          @initSearchPlace="initSearchPlace"
          @outOfCenter="showResultSearchPlace = false"
          @closeInfoWindow="closeInfoWindow"
        />
      </v-flex>

      <!-- DIALOG APPLY FILTERS HOME -->
      <v-dialog
        v-model="showFilterApplyHome"
        max-width="250"
        persistent>
        <v-card
          class="text-xs-center py-2"
          height="125">
          <h3>
            Aplicando Filtro
          </h3>
          <v-progress-circular
            class="mt-3"
            :size="50"
            color="primary"
            indeterminate>
          </v-progress-circular>
        </v-card>
      </v-dialog>

      <!-- DIALOG FILTERS HOME -->
      <v-dialog
        v-model="showFilterHome"
        max-width="500px"
        persistent>
        <home-filter :mapref="mapRef" />
      </v-dialog>

      <!-- DIALOG LOADING ALL VEHICLE DATA -->
      <!-- v-if="$loading.isLoading('fetchLastPositions') || $loading.isLoading('fetchingAgenciesTree')" -->
      <v-dialog
        v-if="showInitDialog"
        v-model="dialogLoading"
        persistent
        max-width="320"
      >
        <v-card
          class="text-xs-center py-2"
          height="160">
          <v-card-title primary-title>
            Actualizando información de todos los vehículos...
          </v-card-title>
          <v-progress-circular
            :size="50"
            color="white"
            indeterminate>
          </v-progress-circular>
        </v-card>
      </v-dialog>

      <gmap-map
        id="mainHomeMap"
        class="AppMap__map"
        :center="center"
        :zoom="zoom"
        ref="mainMap"
        :options="mapOptions"
        @zoom_changed="mapChanged"
        @dragend="mapChanged"
      >
          <!-- v-for="(path, index) in filterZonePath" -->
          <gmap-polygon
            v-for="(path, index) in allPaths"
            :key="`${index}MP`"
            :paths="path"
            :options="polygonOptions"
          />

          <!-- <gmap-info-window
            style="background-color:black;"
            :options="infoOptions"
            :position="infoWindowPos"
            :opened="infoWinOpen"
            @closeclick="setInfoWinOpen(false)"
          > -->

          <gmap-polygon
            v-for="(path, index) in neighborhoodsPath"
            :key="`${index}N`"
            :paths="path"
            :options="polygonOptions1"
            @click="showPolygonNameIn($event, {index, key: 'neighborhoods'})"
          />

          <gmap-polygon
            v-for="(path, index) in communesPath"
            :key="`${index}C`"
            :paths="path"
            :options="polygonOptions2"
            @click="showPolygonNameIn($event, {index, key: 'communes'})"
          />

          <gmap-polygon
            v-for="(path, index) in quadrantsPath"
            :key="`${index}Q`"
            :paths="path"
            :options="polygonOptions3"
            @click="showPolygonNameIn($event, {index, key: 'quadrants'})"
          />

          <gmap-polygon
            v-for="(path, index) in stationsPath"
            :key="`${index}S`"
            :paths="path"
            :options="polygonOptions4"
            @click="showPolygonNameIn($event, {index, key: 'stations'})"
          />

          <gmap-polygon
            v-for="(path, index) in empasPath"
            :key="`${index}E`"
            :paths="path"
            :options="polygonOptions7"
            @click="showPolygonNameIn($event, {index, key: 'empas'})"
          />

          <gmap-polygon
            v-for="(path, index) in districtsPath"
            :key="`${index}D`"
            :paths="path"
            :options="polygonOptions5"
            @click="showPolygonNameIn($event, {index, key: 'districts'})"
          />

          <gmap-polygon
            v-for="(path, index) in firefightersPath"
            :key="`${index}F`"
            :paths="path"
            :options="polygonOptions6"
            @click="showPolygonNameIn($event, {index, key: 'firefighters'})"
          />
        <!-- <map-vehicle-markers
          @centerMarker="handleCenterMarker"/> -->
        <!-- <gmap-marker
          v-if="vehicles.length > 0"
          v-for="vehicle in vehicles" 
          :key="vehicle.vehicleId" 
          :position="vehicle.position" 
          :icon="lastPositionMarker"
          :label="String(vehicle.vehicleId)"
        /> -->
          <!-- v-if="lastPositionFiltered.length > 0" -->
        <div v-if="!isFiltering">
          <gmap-info-window
            style="background-color:black;"
            :options="infoOptions"
            :position="infoWindowPos"
            :opened="infoWinOpen"
            @closeclick="closeInfoWindow"
          >
            <v-flex info-window-container-content>
              <v-flex pt-1>
                <v-icon 
                  size="28"
                  :color="stateColor(infoContent).color">
                  lens
                </v-icon>
              </v-flex>
              <v-flex pt-1>
                <p>
                  <span>Código/Sigla:</span> {{ infoContent.code }}
                </p>
              </v-flex>
              <v-flex pt-1>
                <p>
                  <span>Placa:</span> {{ infoContent.licensePlate }}
                </p>
              </v-flex>
              <v-flex pt-1>
                <p>
                  <span>Agencia:</span> {{
                    infoContent === ''
                      ? ''
                      : agenciesMap.get(infoContent.agencyId).name
                  }}
                </p>
              </v-flex>
              <v-flex pt-1>
                <p>
                  <span>Condición Vehículo:</span> {{ infoContent.status }}
                </p>
              </v-flex>
              <v-flex pt-1>
                <div
                  class="text-button pa-2 caption"
                  @click="gotoVehicleView(infoContent.vehicle)"
                >
                  Ver más...
                </div>
              </v-flex>
            </v-flex>
          </gmap-info-window>
          <div class="marker-style">
            <gmap-marker
              v-for="vehicle in currentMarkers"
              :key="vehicle.id" 
              :position="vehicle.location"
              :icon="{
                url: marker(vehicle),
                labelOrigin: {x: 25, y: 37}
              }"
              :label="{
                text: String(vehicle.code),
                color: '#212121',
                fontWeight: '700'
              }"
              :opacity="vehicleSelectedFromMarker === vehicle.id ? 1 : opacityMarker"
              @dblclick="gotoVehicleView(vehicle)"
              @click="showVehicleInfo(vehicle, $event)"
            />
          </div>
        </div>
        <!-- MARKER PLACES -->
        <div v-if="showResultSearchPlace">
          <gmap-info-window
            style="background-color:black;"
            :options="infoPlaceOptions"
            :position="infoWindowPlacePos"
            :opened="infoWinPlaceOpen"
            @closeclick="infoWinPlaceOpen = false"
          >
            <v-flex info-window-place-container-content>
              <v-flex pt-1>
                <div class="body-2">
                  {{ infoPlaceContent.name }}
                </div>
              </v-flex>
              <v-flex pt-1>
                <div class="caption">
                  {{ infoPlaceContent.formattedAddress }}
                </div>
              </v-flex>
            </v-flex>
          </gmap-info-window>
          <gmap-marker
            :animation="2"
            :position="centerSetPlace"
            :icon="selectPointMarker"
            @click="infoWinPlaceOpen = true"
          />
        </div>
        <!-- <gmap-marker
          v-if="showCameras"
          v-for="camera in cameras" 
          :key="camera.id" 
          :position="{lat: camera.lat, lng: camera.lng}"
          :icon="{
            url: markerCamara,
            scaledSize: iconScaledSize
          }"
        /> -->
      </gmap-map>
      
      <v-flex style="min-width:350px;max-width:350px;height: 100%;">
        <app-list-vehicles
          :mapref="mapRef"
          :trafficlayer="trafficLayer"
          @centerMarker="handleCenterMarker"
          @showCamerasEvent="showCamerasEvent"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import Vue from 'vue'
  /**
   * Configuración basica para los mapas del proyecto
   * @module utils/mapOptions
   */
  import mapOptions from '../utils/mapOptions'

  import AppListVehicles from './AppListVehicles'
  import MapVehicleMarkers from './MapVehicleMarkers'
  import HomeFilter from './HomeFilter'
  import OfficialZones from './OfficialZones'
  import PlaceSearcher from './PlaceSearcher'
  import InfoBubblePolygonName from './InfoBubblePolygonName'

  import {mapGetters, mapActions} from 'vuex'

  import {iconMarkers, SELECTED_POSITION_MARKER_RED} from '../utils/staticsRef'

  // import axios from 'axios'

  // import {CAMERAS} from '../utils/cameras'

  import {gmapApi} from 'vue2-google-maps'

  // import {areasMixin} from '../mixins/areasMixin'
  import { officialZonesMixin } from '../mixins/officialZonesMixin'
  import { placeSearcherMixin } from '../mixins/placeSearcherMixin'
  import { vehicleStatesMixin } from '../mixins/vehicleStatesMixin'

  import {CITY_LAYERS} from '../utils/endpoints'

  import zoomMapBoundaries from '../utils/zoomMapBoundaries'

  // import { zonesNamesRefs } from '../utils/zonesHelpers'

  // const cityLayerMap = new Map([
  //   [ 0, '' ],
  //   [ 1, '19' ],
  //   [ 2, '10,25' ],
  //   [ 3, '23' ]
  // ])
  const cityLayerMap = new Map([
    [ 0, '' ],
    [ 1, '0,1' ]
  ])

  /**
   * Componente que muestra el mapa y la lista de vehiculos, y funciona como ruta base para `/vehicles`
   * @author Manuel Ochoa
   */
  export default {
    name: 'base-vehicles',
    components: {
      OfficialZones,
      AppListVehicles,
      MapVehicleMarkers,
      HomeFilter,
      PlaceSearcher,
      InfoBubblePolygonName
    },
    mixins: [officialZonesMixin, placeSearcherMixin, vehicleStatesMixin],
    data() {
      return {
        cityLayer1: null,
        cityLayer2: null,
        cityLayer3: null,
        /**
         * @property {Object} center - Objecto con Latititud y Longitud la cual equivale al centro de Medellin para el componente `<gmap-map/>`
         */
        center: {
          lat: 6.254790211409118,
          lng: -75.551029793457
        },
        zoom: 13,
        mapOptions,
        // lastPositionMarker: LAST_POSITION_MARKER,
        dialogLoading: true,
        // dialogFilters: true
        mapRef: null,
        trafficLayer: null,
        // cameras: [],
        // markerCamara: '/static/marker-yellow.png',
        iconScaledSize: null,
        showCameras: false,
        polygonOptions: {
          strokeColor: '#2196F3',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#2196F3',
          fillOpacity: 0.35,
          zIndex: 2000
        },
        selectPointMarker: SELECTED_POSITION_MARKER_RED,
        infoPlaceOptions: {
          pixelOffset: {
            width: 0,
            height: -45
          },
          maxWidth: 290
        },
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -45
          },
          minWidth: 290
        },
        infoWindowPlacePos: null,
        infoWinPlaceOpen: false,
        infoWindowPos: null,
        // infoWinOpen: false,
        infoContent: '',
        // infoOfficialFenceSelected: {},
        // showOfficialFenceName: false,
        opacityMarker: 1,
        vehicleSelectedFromMarker: null
      }
    },
    watch: {
      cityLayer(newValue, oldValue) {
        // console.log('WATCH: ', newValue, oldValue)
        if (oldValue !== 0) this[`cityLayer${oldValue}`].setMap(null)

        if (newValue > 0) {
          const getLayers = cityLayerMap.get(newValue)
          const imageBounds = this.mapRef.getBounds()
          const neBound = imageBounds.getNorthEast()
          const swBound = imageBounds.getSouthWest()
          const mapSizeW = document.getElementById('mainHomeMap').offsetWidth
          const mapSizeH = document.getElementById('mainHomeMap').offsetHeight
          const mapSize = `${mapSizeW},${mapSizeH}`
          // console.log('MAP SIZE: ', mapSize)

          this[this.layer] = new google.maps.GroundOverlay(
            CITY_LAYERS +
            swBound.lng() + ',' + swBound.lat() + ',' + neBound.lng() + ',' + neBound.lat() +
            '&layers=show:' +
            getLayers +
            '&size=' +
            mapSize +
            '&format=png32&f=image&transparent=true&bboxSR=4326&imageSR=4326&layers=show:',
            imageBounds
          )
          // this[this.layer] = new google.maps.GroundOverlay(
          //   CITY_LAYERS +
          //   swBound.lng() + ',' + swBound.lat() + ',' + neBound.lng() + ',' + neBound.lat() +
          //   '&bboxSR=4326&layers=show:' +
          //   getLayers +
          //   '&format=png&f=image' +
          //   '&transparent=true',
          //   imageBounds
          // )
          this[this.layer].setMap(this.mapRef)
          // if (newValue === 1) this.mapRef.setZoom(19)
          // else if (newValue === 2) this.mapRef.setZoom(14)
          // else if (newValue === 3) this.mapRef.setZoom(12)
        } else {
          // this.mapRef.setZoom(13)
          this[`cityLayer${oldValue}`].setMap(null)
        }
      }
    },
    computed: {
      ...mapGetters({
        vehicles: 'realTimeVehicles',
        // isAuthenticated: 'auth/authenticated',
        paths: 'geostringFilters'
      }),
      ...mapGetters([
        'officialZonesHome',
        'fromRoute',
        'isFiltering',
        'inMissionFilter',
        'showClearFilterBtn',
        'lastPositionSearch',
        'filterByAZ',
        'filterCondition',
        'lastPositionFilteredCondition',
        'showCityLayer',
        'cityLayer',
        'filterApplied',
        'showInitDialog',
        'superParents',
        'agenciesMap',
        'vehicleTypes',
        // 'lastPositionsInit',
        'lastPositionFiltered',
        'showFilterHome',
        'filterType',
        'showFilterApplyHome',
        'currentMarkersLength',
        'infoWinOpen'
      ]),
      currentMarkers() {
        // console.log('CURRENT MARKERS', this.lastPositionFilteredCondition.length, this.lastPositionFiltered.length, this.filterCondition)
        let markers = []

        // markers = this.lastPositionFiltered.length > 0 ? this.lastPositionFiltered : []
        if (!this.filterCondition && !this.inMissionFilter) markers = this.lastPositionFiltered
        else if (this.lastPositionFilteredCondition.length > 0) markers = this.lastPositionFilteredCondition

        if (this.lastPositionSearch.length > 0) markers = this.lastPositionSearch

        // console.log('MARKERS', markers)
        this.setCurrentMarkersLength(markers.length)

        // Set only the vehicles in the current view of the map
        const markersInside = []
        if (this.mapRef) {
          const curretMapBounds = this.mapRef.getBounds().toJSON()
          const polygon = new google.maps.Polygon({
            paths: [
              new google.maps.LatLng(curretMapBounds.north, curretMapBounds.west),
              new google.maps.LatLng(curretMapBounds.north, curretMapBounds.east),
              new google.maps.LatLng(curretMapBounds.south, curretMapBounds.east),
              new google.maps.LatLng(curretMapBounds.south, curretMapBounds.west)
            ]
          })
          // console.log('POLYGON', polygon)
          for (let index = 0; index < markers.length; index++) {
            const element = markers[index]
            const location = new google.maps.LatLng(element.location.lat, element.location.lng)
            // console.log('LOCATION', location)
            const markerInside = google.maps.geometry.poly.containsLocation(location, polygon)
            // console.log('MARKER INSIDE', index, markerInside)
            if (markerInside) markersInside.push(element)
          }
        }
        // console.log('MARKERS INSIDE', markersInside)

        return markersInside
      },
      layer() {
        return `cityLayer${this.cityLayer}`
      },
      allPaths() {
        const value = this.paths
        // console.log('ALL PATHS')
        if (value) {
          const coords = []
          if (typeof (value) === 'string') {
            const decode = google.maps.geometry.encoding.decodePath(value)
            coords.push(decode)
          } else if (Array.isArray(value)) {
            value.forEach(element => {
              const decode = google.maps.geometry.encoding.decodePath(element)
              coords.push(decode)
            })
          }
          this.coordsIn = coords
          // console.log('FILTER APPLIED', this.filterApplied)
          if (!this.filterApplied) {
            let bounds = []
            if (coords.length === 2) {
              bounds = this.fitMap(coords[0].concat(coords[1]))
            } else {
              bounds = this.fitMap(coords[0])
            }
            // console.log('IN', this.mapRef)
            const area = zoomMapBoundaries(bounds)
            if (area > 100000) {
              // console.log('Area BM > 100000')
              this.mapRef.fitBounds(bounds)
            } else {
              const extraPadding = 350
              // console.log('Area BM <= 100000')
              this.mapRef.fitBounds(bounds, extraPadding)
              // this.mapOptions.zoom = 17
            }
            this.setFilterApplied(true)
          }
          // console.log('COORDS: ', coords)
          return coords
        }
        return null
      },
      google: gmapApi
    },
    methods: {
      ...mapActions([
        'clearAllOfficialPolygons',
        'fetchOfficialZonesHome',
        'setIsFiltering',
        'setFilterByAZ',
        'setIgnitionFilter',
        'setStateVehicleSelectedFilter',
        'clearFilterSearch',
        'agencySelectedAction',
        'setCurrentMarkersLength',
        'setFilterApplied',
        'displayFiltersHome',
        'selectVehicle',
        'setInfoWinOpen',
        'setLogHistoryFront'
      ]),
      clearFilter() {
        // this.setFilterByAZ(false)
        this.vehicleSelectedFromMarker = null
        this.opacityMarker = 1
        this.setIgnitionFilter(null)
        this.setStateVehicleSelectedFilter([])
        this.agencySelectedAction(null)
        this.clearFilterSearch(this.mapRef)
        // this.applyFilterCondition()
        this.setInfoWinOpen(false)
      },
      mapChanged() {
        if (this.mapRef === null || this.mapRef === undefined || !this.showCityLayer) return
        // console.log('MAP CHANGED!', this.mapRef)
        const getLayers = cityLayerMap.get(this.cityLayer)
        if (this[this.layer] !== null) this[this.layer].setMap(null)
        const imageBounds = this.mapRef.getBounds()
        const neBound = imageBounds.getNorthEast()
        const swBound = imageBounds.getSouthWest()
        const mapSizeW = document.getElementById('mainHomeMap').offsetWidth
        const mapSizeH = document.getElementById('mainHomeMap').offsetHeight
        const mapSize = `${mapSizeW},${mapSizeH}`
        // console.log('MAP SIZE: ', mapSize)

        this[this.layer] = new google.maps.GroundOverlay(
          CITY_LAYERS +
          swBound.lng() + ',' + swBound.lat() + ',' + neBound.lng() + ',' + neBound.lat() +
          '&layers=show:' +
          getLayers +
          '&size=' +
          mapSize +
          '&format=png32&f=image&transparent=true&bboxSR=4326&imageSR=4326&layers=show:',
          imageBounds
        )

        // this[this.layer] = new google.maps.GroundOverlay(
        //   CITY_LAYERS +
        //   swBound.lng() + ',' + swBound.lat() + ',' + neBound.lng() + ',' + neBound.lat() +
        //   '&bboxSR=4326&imageSR=4326&size=1496.91,930&layers=show:' +
        //   getLayers +
        //   '&format=png&f=image' +
        //   '&transparent=true',
        //   imageBounds
        // )
        this[this.layer].setMap(this.mapRef)
      },
      showCamerasEvent(value) {
        this.showCameras = value
      },
      // getCameras() {
      //   // console.log('getCameras', lat, lng)
      //   axios.get('https://strauss.seguridadenlinea.com/v1/cameras', {
      //     params: {
      //       around_to_coordenates: this.center.lat + ',' + this.center.lng,
      //       around_to_distance: 0.31 // 3.31 millas son 500 metros
      //     }
      //   })
      //     .then(response => {
      //       console.log('CAMERAS: ', response)
      //     })
      //     .catch(error => {
      //       console.log('ERROR CAMERS: ', error)
      //     })
      // },
      gotoVehicleView(vehicle) {
        // console.log('VEHICLE ID :', vehicle.id)
        this.selectVehicle(vehicle)
        this.$router.push({name: 'AppVehicleViwer', params: {vehicle_id: vehicle.id}})
      },
      marker(vehicle) {
        const vehicleTypeResult = this.vehicleTypes.get(vehicle.vehicleType)
        let vehicleType = 'V'
        if (vehicleTypeResult === 'MOTOCICLETA') vehicleType = 'M'

        const ignitionStatus = vehicle.location.ignitionStatus
        let vehicleState = 'OFF'
        if (ignitionStatus === 1) vehicleState = 'ON'

        // Palette derived from the agency tree's super-parent counter.
        // Only palettes 1..10 have icons, so wrap the counter into that range
        // (same mechanism palettes 8/9 already use to reuse 1/2): this way a
        // newly added root agency (e.g. Policía DEANT) gets a real color just
        // like every other agency, instead of an out-of-range key that renders
        // Google's default red pin. Guard against agencies missing from the map.
        let superAgency = '10'
        if (vehicle.agencyId !== null && vehicle.agencyId !== undefined && this.agenciesMap) {
          const agencyEntry = this.agenciesMap.get(vehicle.agencyId)
          if (agencyEntry) {
            const counter = this.superParents.get(agencyEntry.superParentId)
            if (counter) superAgency = String(((counter - 1) % 10) + 1)
          }
        }

        const key = `MARKER_${vehicleType}_A_${superAgency}_${vehicleState}`

        return iconMarkers[key] || iconMarkers[`MARKER_${vehicleType}_A_10_${vehicleState}`] || iconMarkers.MARKER_V_A_10_OFF
      },
      /**
       * Función que se realizar al recibir el evento `centerMarker` desde el componente `<map-vehicle-markers/>` y `<app-list-vehicles/>`
       *
       * Centra el mapa con un par de coordenadas
       *
       * @param lat
       * @param lng
       */
      handleCenterMarker({lat, lng}) {
        this.center = {lat, lng}
        this.zoom = 17
      },
      fitMap(coords) {
        const bounds = new google.maps.LatLngBounds()
        coords.forEach(element => {
          bounds.extend(element)
        })
        return bounds
      },
      showVehicleInfo(vehicle, event) {
        this.vehicleSelectedFromMarker = vehicle.id
        this.opacityMarker = 0.5
        this.showOfficialFenceName = false
        this.infoWindowPos = {
          lat: vehicle.location.lat,
          lng: vehicle.location.lng
        }
        const dataToShowToInfoWindow = {
          code: vehicle.code,
          licensePlate: vehicle.licensePlate,
          status: vehicle.status.translatedName,
          agencyId: vehicle.agencyId,
          stoppedTimeSinceV2: vehicle.stoppedTimeSinceV2
        }
        this.infoContent = { ...dataToShowToInfoWindow, vehicle }
        this.infoContent.vehicle = vehicle
        this.setInfoWinOpen(true)

        // Register the log related with the action of
        // read info of a vehicle using a Marker on map
        const payload = {
          event: 'read',
          eventDescription: 'vehicle',
          dataAction: dataToShowToInfoWindow,
          product: 'micro-avl',
          modelId: vehicle.id,
          modelType: 'map'
        }
        this.setLogHistoryFront(payload)
      },
      showPolygonNameIn(event, payload) {
        this.vehicleSelectedFromMarker = null
        this.opacityMarker = 1
        this.setInfoWinOpen(false)

        this.showPolygonName(event, payload)
        // Vue.set(
        //   this.infoOfficialFenceSelected,
        //   'name',
        //   this[`${payload.key}Selected`][payload.index]
        // )
        // Vue.set(
        //   this.infoOfficialFenceSelected,
        //   'zone',
        //   zonesNamesRefs.get(payload.key).name
        // )
        // Vue.set(
        //   this.infoOfficialFenceSelected,
        //   'color',
        //   zonesNamesRefs.get(payload.key).color
        // )
        // this.$refs.infoBubbleOFRef.style.position = 'absolute'
        // this.$refs.infoBubbleOFRef.style.left = `${event.domEvent.x - 80}px`
        // this.$refs.infoBubbleOFRef.style.top = `${event.domEvent.y - 68}px`
        // this.$refs.infoBubbleOFRef.style.zIndex = 7
        // this.showOfficialFenceName = true
      },
      closeInfoWindow() {
        this.vehicleSelectedFromMarker = null
        this.opacityMarker = 1
        this.setInfoWinOpen(false)
      }
    },
    created() {
      // this.cameras = CAMERAS
      // console.log('CAMERAS: ', this.cameras)
    },
    mounted() {
      this.$refs.mainMap.$mapPromise.then((map) => {
        setTimeout(() => {
          // console.log(map)
          this.mapRef = map
          this.trafficLayer = new google.maps.TrafficLayer
          this.iconScaledSize = new google.maps.Size(36, 36)
          // const imageBounds = map.getBounds()
          // console.log(imageBounds)
          // const neBound = imageBounds.getNorthEast()
          // const swBound = imageBounds.getSouthWest()
          // console.log(imageBounds, neBound, swBound, swBound.lng())

          // this.cityLayer1 = new google.maps.GroundOverlay(
          //   CITY_LAYERS +
          //   swBound.lng() + ',' + swBound.lat() + ',' + neBound.lng() + ',' + neBound.lat() +
          //   '&bboxSR=4326&layers=show:17' +
          //   '&format=png&f=image' +
          //   '&transparent=true',
          //   imageBounds
          // )
          // console.log('CITY LAYER 1: ', this.cityLayer1)
          // this.cityLayer1.setMap(map)
        }, 2000)
        // this.trafficLayer.setMap(map)
        // console.log('MOUNTED', this.mapRef, this.google)

        map.addListener('zoom_changed', () => {
          this.showOfficialFenceName = false
        })
        map.addListener('drag', () => {
          this.showOfficialFenceName = false
        })
      })
    },
    async activated() {
      // console.log('ACTIVATED: route name', this.$route.name)
      if (this.fromRoute.name === 'AppVehicleViwer') {
        await this.clearAllOfficialPolygons()
        if (this.officialZonesHome) this.fetchOfficialZonesHome()
      }
    }
  }
</script>

<style lang="stylus" scoped>
p {
  margin-bottom: 1px;
  color: white;
  font-weight: 400;
}

span {
  font-weight: 600;
  color: #9E9E9E;
}

.show-filter-style
  max-width 450px
  min-width 450px

.btn-absolute {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 5;
}

.info-filter-absolute {
  position: relative;
  // top: 16px;
  left: -240px;
  // z-index: 5;
  height: 36px;
  background-color: #212121;
  border-radius: 2px;
}

.highlight-text {
  font-size: 18px;
  background: #2196F3;
  color: #FAFAFA;
  padding-left: 5px;
  padding-right: 5px;
  margin-left: 15px;
  border-radius: 2px;
}

.info-window-place-container-content,
.info-window-container-content {
  background-color: #212121;
  border-radius: 6px;
  padding: 7px;
}

.text-button {
  cursor: pointer;
  text-align: end;
}

.text-button:hover {
  opacity: 0.75;
}

.marker-style {
  border: dashed red;
}
</style>



// WEBPACK FOOTER //
// src/components/BaseVehicles.vue